const footerString = `
	<div class="footer-main">
		<div class='footer-text'>
      © ${new Date().getFullYear()} Navy Mutual Aid Association
		</div>
    <div class='footer-links'>
      <div>
        <a href="https://www.navymutual.org/privacy-policy/"  aria-label="Privacy Policy (opens a new window)"  rel="noopener noreferrer" target="_blank">Privacy Policy</a> | 
      </div>
      <div>
        &nbsp;<a href="https://www.navymutual.org/terms-of-use/"  aria-label="Terms of Use (opens a new window)" rel="noopener noreferrer" target="_blank">Terms of Use</a>
      </div>
    </div>
	</div>
`;

export default footerString;
